import React from 'react';
import { Loading } from '@alifd/next';

export default () => (
  <div style={{ padding: '150px 0', textAlign: 'center' }}>
    <Loading tip="加载中..." style={{ display: 'block' }} />
  </div>
);
